export default "/assets/images/crittercuddler-filter.50ec68e62c565eba.png";